import {Injectable} from "@angular/core";
import {DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable} from "rxjs";
import {UserService} from "../../../../@shared/services/user.service";
import {IUserPayback} from "../../../../@core/enums/payback/interfaces/payback.interface";


@Injectable()
export class PaybackDataSource extends DataSource<IUserPayback> {

  paybacks$: BehaviorSubject<IUserPayback[]> = new BehaviorSubject<IUserPayback[]>([]);
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  totalCount!: number;

  constructor(private userService: UserService) {
    super();
  }

  connect = (): Observable<IUserPayback[]> => this.paybacks$.asObservable();
  disconnect = () => this.paybacks$.complete();

  loadData(): void {
    this.isLoading$.next(true);

    this.userService.getPaybacks()
      .subscribe((paybacks: IUserPayback[]) => {
        this.paybacks$.next(paybacks);
        this.totalCount = paybacks.length!;
        this.isLoading$.next(false);
      });
  }
}
